import { $http } from '@/utils';

/**
 * @namespace Service
 * @class Will
 * @exports Service/Will
 * @description API Will Service
 * @date 2021/04/01
 * @license no license
 * @copywrite Answers In Retirement Limited
 */
export default class Will {
	/**
	 * @static @name list
	 * @description Get a list of referrals
	 * @param {Object} payload
	 * @returns {Object} Promise a http response
	 */
	static list(payload) {
		return $http.post('will/list', payload);
	}
	/**
	 * @static @name post
	 * @description Add a new Will resource
	 * @param {Object} payload
	 * @returns {Object} Promise a http response
	 */
	static post(payload) {
		return $http.post('will', payload);
	}
}
